import * as types from './types'
import {
  GETLabourRateDefaultsResponse,
  GETLabourRateResponse,
  GETLabourRatesResponse,
  POSTLabourRateBody,
  POSTLabourRateResponse,
  PUTLabourRateBody,
  PUTLabourRateDefaultsRequest,
  PUTLabourRateResponse
} from '@cbgms/api/modules/labourrates'
import { IPaginatedRequest } from '@cbgms/api/request'
import { AsyncAction } from '@cbgms/base/redux/async-action'

export const loadLabourRates = (params: IPaginatedRequest = {}) =>
  AsyncAction<GETLabourRatesResponse>({
    type: [types.LOAD_LABOUR_RATES, types.LOAD_LABOUR_RATES_SUCCESS, types.LOAD_LABOUR_RATES_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: '/modules/labour-rates',
        params
      }
    }
  })

export const loadLabourRate = (labourRateUUID: string) =>
  AsyncAction<GETLabourRateResponse>({
    type: [types.LOAD_LABOUR_RATE, types.LOAD_LABOUR_RATE_SUCCESS, types.LOAD_LABOUR_RATE_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: `/modules/labour-rates/${labourRateUUID}`
      }
    }
  })

export const createLabourRate = (body: POSTLabourRateBody) =>
  AsyncAction<POSTLabourRateResponse>({
    type: [types.CREATE_LABOUR_RATE, types.CREATE_LABOUR_RATE_SUCCESS, types.CREATE_LABOUR_RATE_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'POST',
        url: '/modules/labour-rates',
        data: body
      }
    }
  })

export const updateLabourRate = (labourRateUUID: string, body: PUTLabourRateBody) =>
  AsyncAction<PUTLabourRateResponse>({
    type: [types.UPDATE_LABOUR_RATE, types.UPDATE_LABOUR_RATE_SUCCESS, types.UPDATE_LABOUR_RATE_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'PUT',
        url: `/modules/labour-rates/${labourRateUUID}`,
        data: body
      }
    }
  })

export const deleteLabourRate = (labourRateUUID: string, dryRun: boolean) =>
  AsyncAction<{}>({
    type: [types.DELETE_LABOUR_RATE, types.DELETE_LABOUR_RATE_SUCCESS, types.DELETE_LABOUR_RATE_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'DELETE',
        url: `/modules/labour-rates/${labourRateUUID}?dryRun=${dryRun}`
      }
    }
  })

export const loadAllLabourRates = () =>
  AsyncAction<GETLabourRatesResponse>({
    type: [types.LOAD_ALL_LABOUR_RATES, types.LOAD_ALL_LABOUR_RATES_SUCCESS, types.LOAD_ALL_LABOUR_RATES_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: '/modules/labour-rates',
        params: {
          PerPage: 99999,
          Fields: 'Code,Description,UUID'
          // Search:
        }
      }
    }
  })

export const loadLabourRateDefaults = () =>
  AsyncAction<GETLabourRateDefaultsResponse>({
    type: [types.LOAD_LABOUR_RATE_DEFAULTS, types.LOAD_LABOUR_RATE_DEFAULTS_SUCCESS, types.LOAD_LABOUR_RATE_DEFAULTS_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: '/settings/haynespro'
      }
    }
  })

export const updateLabourRateDefaults = (body: PUTLabourRateDefaultsRequest) =>
  AsyncAction<PUTLabourRateResponse>({
    type: [types.UPDATE_LABOUR_RATE_DEFAULTS, types.UPDATE_LABOUR_RATE_DEFAULTS_SUCCESS, types.UPDATE_LABOUR_RATE_DEFAULTS_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'PUT',
        url: '/settings/haynespro',
        data: body
      }
    }
  })
